import React from "react";
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      image: require("../../assets/img6.jpg"),
      id: 1,
      name: "AIVSC CAMP",
      test: "Selected for the prestigious AIVSC camp of Air NCC Wing in Bangalore, I earned the remarkable chance to soar in Zenair aircraft. Grateful for this honor.",
    },
    {
      image: require("../../assets/img2.jpg"),
      id: 2,
      name: "3rd year of my ncc journey",
      test: "Attended CATC camp in Indore and achieving the C Certificate in the Air Wing NCC in Indore marks the culmination of my NCC journey. Grateful for the enriching experiences.",
    },
    {
      image: require("../../assets/img3.jpg"),
      id: 3,
      name: "2nd year of my NCC journey",
      test: "In my penultimate year of NCC Air Wing, I aim to excel and earn my B certificate. Through rigorous training and dedication, I strive to demonstrate leadership and proficiency in aviation skills.",
    },
    {
      image: require("../../assets/img4.jpg"),
      id: 4,
      name: "1st year of my NCC journey",
      test: "Being selected for Air Wing NCC after my initial training year is a testament to my dedication and potential. I eagerly anticipate honing my skills and contributing actively to the unit.",
    },
  ];
  return (
    <section id="testmonials">
      <h5>MY NCC Journey</h5>
      <h2>1 M.P. AIR SQN NCC INDORE</h2>
      <Swiper
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {testimonials.map((test) => (
          <SwiperSlide className="testimonial" key={test.id}>
            <div className="client__avatar">
              <img src={test.image} alt="images" />
            </div>
            <h5 className="client__name">{test.name}</h5>
            <small className="client__review">{test.test}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
